/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Raw Logging service icon.
 * @export
 */
export const ICON_LOGS = (
  <svg fill="none" height="24" viewBox="0 0 28 28" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M4 0C1.79086 0 0 1.79086 0 4V22C0 25.3137 2.68629 28 6 28H24C26.2091 28 28 26.2091 28 24V6C28 2.68629 25.3137 0 22 0H4ZM4 8C4 6.89543 4.89543 6 6 6C7.10457 6 8 6.89543 8 8V14C8 15.1046 7.10457 16 6 16C4.89543 16 4 15.1046 4 14V8ZM8 20C8 21.1046 7.10457 22 6 22C4.89543 22 4 21.1046 4 20C4 18.8954 4.89543 18 6 18C7.10457 18 8 18.8954 8 20ZM14 6C12.8954 6 12 6.89543 12 8C12 9.10457 12.8954 10 14 10H22C23.1046 10 24 9.10457 24 8C24 6.89543 23.1046 6 22 6H14ZM12 14C12 12.8954 12.8954 12 14 12H22C23.1046 12 24 12.8954 24 14C24 15.1046 23.1046 16 22 16H14C12.8954 16 12 15.1046 12 14ZM14 18C12.8954 18 12 18.8954 12 20C12 21.1046 12.8954 22 14 22H22C23.1046 22 24 21.1046 24 20C24 18.8954 23.1046 18 22 18H14Z"
      fillRule="evenodd"
    />
  </svg>
);
